export const GET_PRIVILEGES = "GET_PRIVILEGES";
export const GET_LIST_PRIVILEGES = "GET_LIST_PRIVILEGES";
export const GET_PRIVILEGE = "GET_PRIVILEGE";
export const SET_PRIVILEGES = "SET_PRIVILEGES";
export const SET_LIST_PRIVILEGES = "SET_LIST_PRIVILEGES";
export const SET_PRIVILEGE = "SET_PRIVILEGE";
export const ADD_PRIVILEGE = "ADD_PRIVILEGE";
export const SET_NEW_PRIVILEGE = "SET_NEW_PRIVILEGE";
export const EDIT_PRIVILEGE = "EDIT_PRIVILEGE";
export const SET_EDIT_PRIVILEGE = "SET_EDIT_PRIVILEGE";
export const SET_DELETE_PRIVILEGE = "SET_DELETE_PRIVILEGE";
export const SET_DELETE_MULTI_PRIVILEGE = "SET_DELETE_MULTI_PRIVILEGE";
export const DELETE_PRIVILEGE = "DELETE_PRIVILEGE";
export const DELETE_MULTI_PRIVILEGE = "DELETE_MULTI_PRIVILEGE";
export const RESET_ITEMS_PRIVILEGE = "RESET_ITEMS_PRIVILEGE";
export const RESET_SELECTED_PRIVILEGE = "RESET_SELECTED_PRIVILEGE";
export const RESET_LIST_PRIVILEGES = "RESET_LIST_PRIVILEGES";
